import React from "react";
import { CropOriginal } from "@material-ui/icons";
import { TableGroup } from "common";
import {DIALOG_CONTEXT_IMAGES, HTTP_REQUEST_PATCH} from "core/utils/constCapsule";
import { connect } from "react-redux";
import { ImagesTable } from "features/ImagesTable";
import { CommentsTable } from "features/CommentsTable";
import { SVGChatBubble } from "images/SVGChatBubble";
import { resolveArrayResponse, fetch } from "lib/util/fetch";
import { useQuery } from "react-query";
import { mapComments } from "core/mappers/comments";
import { buildAPIUrl } from "core/utils/urls";
import { API_PATHS } from "core/config/urls";
import { useDialogContext } from "core/hooks/useDialogContext";
import { AddImagesButton } from "features/AddImagesButton";
import { ImagesDialog } from "features/ImagesDialog";
import { useActiveRow } from "common/Table/hooks";
import { USER_LICENSES } from "core/config/licenses";
import { hasLicense } from "core/store/selectors/UserSelectors";

async function fetchComments(order_id, ordersType) {
  const response = await fetch({
    url: buildAPIUrl({
      path: API_PATHS.FACTORING_COMPANY_PAYMENTS_DUE_ORDERS_COMMENTS,
      queryParams: { order_id: order_id, ordersType }
    }),
    transformResponse: mapComments,
    method: HTTP_REQUEST_PATCH
  });
  return resolveArrayResponse(response);
}

const queryConfig = {
  retry: false,
  staleTime: 120000 // 2 Minutes
};

function DetailsDrawerPresentation({ order_id, movementId, hasImagingLicense = false }) {
  const [dialogContext, toggleDialog] = useDialogContext(null);
  const commentsQuery = useQuery([order_id, "comments"], fetchComments, queryConfig);
  const { inlineIndex, setInlineIndex } = useActiveRow(movementId);
  const handleChange = (idx) => setInlineIndex(idx);

  const tables = [
    {
      Table: <CommentsTable {...commentsQuery} />,
      label: "Comments",
      Icon: <SVGChatBubble />
    }
  ];

  if (hasImagingLicense) {
    tables.push({
      Table: <ImagesTable movementId={movementId} />,
      label: "Images",
      Icon: <CropOriginal />
    });
  }

  return (
    <>
      <TableGroup
        inline
        tables={tables}
        value={inlineIndex}
        onChange={handleChange}
        renderActions={() =>
          hasImagingLicense ? (
            <AddImagesButton onClick={toggleDialog(DIALOG_CONTEXT_IMAGES)} />
          ) : null
        }
      />
      {hasImagingLicense && (
        <ImagesDialog
          orderId={order_id}
          movementId={movementId}
          open={dialogContext === DIALOG_CONTEXT_IMAGES}
          onClose={toggleDialog(DIALOG_CONTEXT_IMAGES)}
        />
      )}
    </>
  );
}

const mapStateToProps = (state) => ({
  hasImagingLicense: hasLicense(state, USER_LICENSES.LOADMASTER_IMAGING_RUN_IMAGING_PROGRAM)
});

export const InlineOrderDetailsDrawer = connect(mapStateToProps)(DetailsDrawerPresentation);
